import { useMutation } from '@apollo/client';
import { gql } from '__generated__/gql';
import { PortfolioUpdateRequestStatusEnumType } from '__generated__/graphql';
import { FC, useState } from 'react';

import ErrorMessage from 'components/ErrorMessage';

import Button from 'primitives/Button';
import { Dialog, DialogActions, DialogPanel, DialogTitle } from 'primitives/Dialog';

const UPDATE_STATUS_MUTATION = gql(`
  mutation ArchivePortfolioUpdateRequest($id: ID!, $status: PortfolioUpdateRequestStatusEnumType!, $leadNote: String) {
    updatePortfolioUpdateRequestStatus(id: $id, status: $status, leadNote: $leadNote) {
      id
      status
      leadNote
    }
  }
`);

const ArchiveRequestDialog: FC<{
  requestId: string;
  onDone: () => void;
}> = ({ requestId, onDone }) => {
  const [open, setOpen] = useState(false);
  const [note, setNote] = useState('');

  const [updateStatus, { loading, error }] = useMutation(UPDATE_STATUS_MUTATION, {
    onCompleted() {
      setOpen(false);
      onDone();
    },
  });

  return (
    <>
      <button
        onClick={() => setOpen(true)}
        className="inline-flex items-center rounded-md border border-gray-300 bg-white px-3 py-1.5 text-xs font-medium text-gray-600 shadow-sm hover:bg-gray-50 hover:border-gray-400 transition-colors"
      >
        Archive
      </button>

      <Dialog open={open} onClose={() => setOpen(false)}>
        <DialogPanel>
          <DialogTitle>Archive this request?</DialogTitle>
          <p className="text-sm text-gray-600 mt-1">
            Optionally leave a note explaining why you're archiving this request.
          </p>
          <div className="mt-3">
            <textarea
              className="w-full rounded-md border border-gray-300 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500"
              rows={3}
              placeholder="Reason (optional)"
              value={note}
              onChange={e => setNote(e.target.value)}
            />
          </div>
          {error && <ErrorMessage error={error} type="alert" />}
          <DialogActions>
            <Button variant="secondary" onClick={() => setOpen(false)}>
              Cancel
            </Button>
            <Button
              loading={loading}
              onClick={() =>
                updateStatus({
                  variables: {
                    id: requestId,
                    status: PortfolioUpdateRequestStatusEnumType.Archived,
                    leadNote: note || null,
                  },
                })
              }
            >
              Archive
            </Button>
          </DialogActions>
        </DialogPanel>
      </Dialog>
    </>
  );
};

export default ArchiveRequestDialog;
